<template>
  <div class="login-form">
    <div class="mb-6">
      <div class="text-h6 text-md-h5 font-weight-black text-grey-darken-4" style="line-height: 1.2;">
        Bienvenido
      </div>
      <div class="text-body-2 text-medium-emphasis mt-1">
        Inicia sesión para continuar con tus solicitudes.
      </div>
    </div>

    <!-- Microsoft -->
    <v-btn
      @click="redirectToMicrosoft()"
      variant="outlined"
      size="large"
      block
      class="text-capitalize font-weight-bold py-4"
      style="border-color: #E5E7EB; background: #FFFFFF; border-radius: 14px;"
    >
      <v-avatar start size="22" style="margin-right: 10px;">
        <v-img :src="require('@/assets/microsoft.svg')" width="22" cover></v-img>
      </v-avatar>
      <span style="letter-spacing: 0.3px;">Continuar con Microsoft</span>
      <v-icon style="font-size: 14px; color: #6B7280; margin-left: 10px;">fa:fa-solid fa-arrow-right</v-icon>
    </v-btn>

    <div class="d-flex align-center my-6">
      <div style="height: 1px; background: #EEF2F7; flex: 1;"></div>
      <div class="text-caption text-medium-emphasis px-3">o con tu correo</div>
      <div style="height: 1px; background: #EEF2F7; flex: 1;"></div>
    </div>

    <div class="mb-3">
      <v-text-field
        v-model="user.email"
        type="email"
        label="Email"
        placeholder="correo@cetemin.edu.pe"
        variant="outlined"
        density="comfortable"
        hide-details="auto"
        bg-color="white"
      >
        <template v-slot:prepend-inner>
          <v-icon style="font-size: 14px; color: #9CA3AF;">fa:fa-regular fa-envelope</v-icon>
        </template>
      </v-text-field>
    </div>

    <div class="mb-2">
      <v-text-field
        v-model="user.password"
        type="password"
        label="Contraseña"
        placeholder="********"
        variant="outlined"
        density="comfortable"
        hide-details="auto"
        bg-color="white"
        @keyup.enter="login()"
      >
        <template v-slot:prepend-inner>
          <v-icon style="font-size: 14px; color: #9CA3AF;">fa:fa-solid fa-lock</v-icon>
        </template>
      </v-text-field>
    </div>

    <div class="d-flex justify-space-between align-center mb-4">
      <v-btn
        variant="text"
        size="small"
        class="text-capitalize px-0"
        style="color: #005691; font-weight: 800;"
        @click="switchComponent('FormResetPassComponent')"
      >
        Olvidé mi contraseña
      </v-btn>
    </div>

    <v-btn
      elevation="0"
      block
      size="large"
      class="font-weight-black py-4 text-capitalize"
      style="background: linear-gradient(135deg, #002B49 0%, #005691 100%); color: white; border-radius: 14px;"
      @click="login()"
    >
      Iniciar sesión
      <v-icon style="font-size: 14px; color: white; margin-left: 10px;">fa:fa-solid fa-arrow-right-to-bracket</v-icon>
    </v-btn>

    <v-alert v-if="errorLogin.type" :type="errorLogin.type" variant="tonal" closable density="compact" class="my-4 pa-2">
      <small>{{ errorLogin.message }}</small>
    </v-alert>

    <div class="d-flex flex-column align-center mt-8">
      <v-img
        :src="require('@/assets/logo-tic.svg')"
        contain
        style="max-width: 140px; max-height: 28px; opacity: 0.85;"
      ></v-img>
      <div class="text-caption text-medium-emphasis mt-2" style="opacity: 0.7;">
        Desarrollado por Equipo TIC - 2025 - v2
      </div>
    </div>
  </div>
</template>

<script>
import utiles from '@/modules/Shared/utiles/utiles';
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  computed:
  {
    ...mapState(['user']),
    ...mapState('login', ['errorLogin'])
  },
  methods: {
    ...mapMutations('login', ['switchComponent']),
    ...mapActions('login', ['login']),
    redirectToMicrosoft() {
      window.location.href = utiles.state.api + 'auth/microsoft'
    }
  }
}
</script>

<style scoped>
:deep(.v-field) {
  border-radius: 14px;
}
</style>

